// Ball State's undergraduate majors (lane 2, #2745). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Catalog's Programs of Study list (catalog.bsu.edu,
// served by SmartCatalog), grouped by the college each program's catalog page sits
// under. Every "Major in", "Dual Major in", "Teaching Major in" and bachelor's degree
// line is kept; minors, certificates, licenses, concentrations and associate degrees
// are left out. Where the catalog offers a major as BA/BS, the degree reads "B.A. or
// B.S."; the catalog's em dashes are written as commas. The Special Education teaching
// major's catalog title names no degree, so none is shown.
const majors = {
    "slug": "ball-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Ball State's official 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Minors, certificates, licenses and associate degrees are left out.",
    "groups": [
        {
            "name": "Estopinal College of Architecture and Planning",
            "source": {
                "label": "Ball State 2026-2027 Undergraduate Catalog, Programs of Study",
                "url": "https://catalog.bsu.edu/en/2026-2027/undergraduate-catalog/programs-of-study"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.Arch."
                },
                {
                    "name": "Architecture",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Construction Management",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Environmental Design",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Interior Design",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "B.L.A."
                },
                {
                    "name": "Urban Planning and Development",
                    "degree": "B.U.P.D."
                }
            ]
        },
        {
            "name": "Miller College of Business",
            "source": {
                "label": "Ball State 2026-2027 Undergraduate Catalog, Programs of Study",
                "url": "https://catalog.bsu.edu/en/2026-2027/undergraduate-catalog/programs-of-study"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Business Analytics and Information Systems",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Business Information Systems",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Entrepreneurship and Innovation",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Fashion Industry Studies",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Hospitality Innovation and Leadership",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Human Resource Management",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Logistics and Supply Chain Management",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Management and Leadership",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Marketing",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Professional Selling",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Property Management",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Risk Management and Insurance",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Business Education (teaching major)",
                    "degree": "B.A. or B.S."
                }
            ]
        },
        {
            "name": "College of Communication, Information, and Media",
            "source": {
                "label": "Ball State 2026-2027 Undergraduate Catalog, Programs of Study",
                "url": "https://catalog.bsu.edu/en/2026-2027/undergraduate-catalog/programs-of-study"
            },
            "majors": [
                {
                    "name": "Applied Cybersecurity",
                    "degree": "B.S."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Computer and Information Technology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Media",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Media Design and Development",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Strategic Communication",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Journalism (teaching major)",
                    "degree": "B.A. or B.S."
                }
            ]
        },
        {
            "name": "College of Fine Arts",
            "source": {
                "label": "Ball State 2026-2027 Undergraduate Catalog, Programs of Study",
                "url": "https://catalog.bsu.edu/en/2026-2027/undergraduate-catalog/programs-of-study"
            },
            "majors": [
                {
                    "name": "Music Education",
                    "degree": "B.M.E."
                },
                {
                    "name": "Animation",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Dance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Graphic Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Graphic Design Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Music Media Production",
                    "degree": "B.S."
                },
                {
                    "name": "Music Performance",
                    "degree": "B.M."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Theatre",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art Education (teaching major)",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Theatre (teaching major)",
                    "degree": "B.A. or B.S."
                }
            ]
        },
        {
            "name": "College of Health",
            "source": {
                "label": "Ball State 2026-2027 Undergraduate Catalog, Programs of Study",
                "url": "https://catalog.bsu.edu/en/2026-2027/undergraduate-catalog/programs-of-study"
            },
            "majors": [
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "B.S."
                },
                {
                    "name": "Dietetics",
                    "degree": "B.S."
                },
                {
                    "name": "Exercise Science",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                },
                {
                    "name": "Respiratory Therapy",
                    "degree": "B.S."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                },
                {
                    "name": "Sport Administration",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Physical Education and Health (teaching major)",
                    "degree": "B.A. or B.S."
                }
            ]
        },
        {
            "name": "College of Sciences and Humanities",
            "source": {
                "label": "Ball State 2026-2027 Undergraduate Catalog, Programs of Study",
                "url": "https://catalog.bsu.edu/en/2026-2027/undergraduate-catalog/programs-of-study"
            },
            "majors": [
                {
                    "name": "General Studies",
                    "degree": "B.G.S."
                },
                {
                    "name": "Actuarial Science",
                    "degree": "B.S."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Astronomy",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Biomedical Science",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Criminal Justice and Criminology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Data Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Geoscience",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Forensic Science",
                    "degree": "B.S."
                },
                {
                    "name": "Geography",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Legal Studies",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Meteorology and Climatology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Modern Languages",
                    "degree": "B.A."
                },
                {
                    "name": "Natural Resources and Environmental Management",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Pre-Engineering",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Psychological Science",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "English/Language Arts (teaching major)",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Modern Languages (teaching major)",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Science (teaching major)",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Social Studies (teaching major)",
                    "degree": "B.A. or B.S."
                }
            ]
        },
        {
            "name": "Teachers College",
            "source": {
                "label": "Ball State 2026-2027 Undergraduate Catalog, Programs of Study",
                "url": "https://catalog.bsu.edu/en/2026-2027/undergraduate-catalog/programs-of-study"
            },
            "majors": [
                {
                    "name": "Early Childhood and Early Childhood Special Education (dual major)",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Elementary Education, Special Education, Exceptional Needs (dual major)",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Applied Behavior Analysis with an Emphasis in Autism",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Early Childhood Education (Pre-K Only Track, No License)",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Family and Child",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Early Childhood Education (Birth-Grade 3) (teaching major)",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Elementary Education (Grades K-6) (teaching major)",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Special Education: Exceptional Needs P-12 (teaching major)",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
